export default __webpack_public_path__ + "static/media/private.ae3dd252.svg";